enum ENotificationComponent {
  DS_POPUP = 'DSPopup',
  DS_ALERT = 'DSAlert',
}

export default ENotificationComponent;
